import $ from "jquery";

const tabNav = $(".services-tabs-dropdown"),
  navItem = $(".nav-item");

tabNav.on("click", function () {
  navItem.show();
});

navItem.on("click", function () {
  let tabId = $(this).attr("data-tab");
  $(this).parents(".container").find(".service-tab").hide();
  $(this)
    .parents(".container")
    .find('.service-tab[data-tab="' + tabId + '"]')
    .show();
  $(this).parent().find(".nav-item").removeClass("active");
  $(this).closest(".services-tabs-dropdown").toggleClass("expanded");
  $(this).addClass("active");
});

$(window).on("resize", function () {
  tabNav.removeClass("expanded");
});

